<template>
  <div class="footer">
    <div class="footer-item">
      数据来源：上海市智慧公证一体化办证平台 ·
      技术支持：上海同道信息技术有限公司
    </div>
    <div class="footer-item">
      ©2008-2022 上海同道信息技术有限公司版权所有 · 沪ICP备05051100号 ·
      沪公网安备31010402004981号
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss" scoped>
.footer {
  padding: 32px 0;
  font-size: 14px;
  color: #888;
  font-weight: 300;
  text-align: center;
  .footer-item {
    padding-top: 10px;
  }
}
</style>